import { useIonViewDidLeave, useIonViewWillEnter, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import React, { useState } from "react";
import { RouteComponentProps } from "react-router-dom";

import { showTab, hideTab } from "../components/Tabs";
import './Main.css'; 

interface ImgViewProp extends RouteComponentProps<{
    img : string
    }> 
{} 

const ImageView : React.FC<ImgViewProp> = ({match}) => {

    useIonViewDidLeave(() => {
        // showTab();
    });

    useIonViewWillEnter(() => {
        hideTab();
    });

    return (
        <IonPage>
            <IonContent fullscreen>
                <IonToolbar className="toolbar-float">
                    <IonButtons slot="start">
                        <IonBackButton className="white-shadow" text="" defaultHref="/main" ></IonBackButton>
                    </IonButtons>
                </IonToolbar>
                <div className="img-wrapper">
                    <img className="img-big" src={ decodeURIComponent(match.params.img) } />
                </div>
            </IonContent>
        </IonPage>
    );
};

export default ImageView;